export default __webpack_public_path__ + "static/media/logo01.f0f3765f.svg";